module.exports = __webpack_public_path__ + "static/img/advantage2.77432255.png";